import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import { cultureCardData } from '@domain/constant/v1/companyType';
import { getFileImg } from '@utils/common';
import classnames from 'classnames/bind';
import styles from './companyCulture.module.scss';

const cx = classnames.bind(styles);

interface CultureCard {
  index: number;
  name: string;
  adjective: string;
  thumbnailImageUid: string;
}

const cardColor = ['GREEN', 'YELLOW', 'SKY'];
const flagText = ['1st', '2nd', '3rd'];

const CultureCard = ({ index, name, adjective, thumbnailImageUid }: CultureCard) => {
  return (
    <div className={cx('card', cardColor[index])}>
      <i className={cx('flag')}>{flagText[index]}</i>
      <span className={cx('subTitle')}>{name}</span>
      <em className={cx('title')}>{adjective}</em>
      <img className={cx('joy')} src={getFileImg(thumbnailImageUid)} alt={'joy'} />
    </div>
  );
};

const descText = ['당신은', '그리고', '또한'];
const CompanyCulture = () => {
  const { accaResultStore } = useResultStore();
  const { accCompanyCuration } = accaResultStore;

  if (!accCompanyCuration) return null;

  const themes = accCompanyCuration.themes?.slice().sort((a, b) => {
    return a.priority < b.priority ? -1 : 1;
  });

  const list = themes?.map((themeCardDto, index) => {
    const { name, adjective, thumbnailImageUid } = themeCardDto;
    return (
      <CultureCard key={index} index={index} name={name} adjective={adjective} thumbnailImageUid={thumbnailImageUid} />
    );
  });

  const desc = themes?.map((themeCardDto, index) => {
    const { type } = themeCardDto;
    return descText[index] + ' ' + cultureCardData[type].contents + ' ';
  });

  return (
    <>
      <div className={cx('cardWrap')}>{list}</div>
      <span className={cx('cultureDesc')}>{desc}</span>
    </>
  );
};

export default CompanyCulture;
